<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('data.add_new_bank_account')" :close-on-click-modal="false" width="739px">
      <div class="header-line" />
      <div class="section-title">Account Details</div>
      <div class="section-tip">{{ $t('tips.enter_bank_accout_detail_add') }}</div>

      <div class="form-container">
        <el-form ref="form" :rules="rule" :model="form" status-icon label-position="top">
          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('data.currency')" prop="currency">
                <el-select
                  v-model="form.currency"
                  class="select-item"
                  clearable
                  @change="onCurrencyChange"
                >
                  <el-option
                    v-for="(item, index) in currencyOptions"
                    :key="item.code || index"
                    :label="item.currency"
                    :value="item.currency"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="2">
              <el-form-item :label="$t('data.account_location')" prop="settlement_country">
                <el-select
                  v-model="form.settlement_country"
                  class="select-item"
                  :disabled="form.currency !== 'USD'"
                >
                  <el-option
                    v-for="item in accountLocationList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('merchant.account_bank')" prop="settlement_bank">
                <el-input
                  v-if="form.currency === 'USD'"
                  v-model="form.settlement_bank"
                  clearable
                  autocomplete="off"
                  placeholder="Enter bank name"
                />
                <el-select
                  v-else
                  v-model="form.settlement_bank"
                  filterable
                  class="select-item"
                  clearable
                  popper-class="bank-select-dropdown"
                >
                  <el-option
                    v-for="(item, index) in bankList"
                    :key="index"
                    :label="item.bank_code + '-' + item.full_name"
                    :value="item.bank_code"
                  >
                    <el-tooltip
                      effect="dark"
                      :content="item.bank_code + '-' + item.full_name"
                      placement="top"
                      :disabled="!item._overflow"
                    >
                      <span class="option-ellipsis" @mouseenter="handleOverflow($event, item)">
                        {{ item.bank_code + '-' + item.full_name }}
                      </span>
                    </el-tooltip>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="2">
              <el-form-item
                v-if="form.currency === 'PHP'"
                :label="$t('merchant.account_num')"
                prop="settlement_bank_account_num_ph"
              >
                <el-input
                  v-model="form.settlement_bank_account_num_ph"
                  clearable
                  type="text"
                  class="input-item"
                  placeholder="Enter Account"
                  autocomplete="off"
                  @change="bankAccountPH"
                />
              </el-form-item>
              <el-form-item v-else :label="$t('merchant.account_num')" prop="settlement_bank_account_num">
                <el-input
                  v-model="form.settlement_bank_account_num"
                  clearable
                  type="text"
                  class="input-item"
                  placeholder="Enter Account"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('data.bank_account_holder')" prop="settlement_bank_account_name">
                <el-input v-model="form.settlement_bank_account_name" clearable autocomplete="off" placeholder="Enter your message here" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('data.bank_address')" prop="settlement_bank_address" :required="form.currency === 'USD'">
                <el-input v-model="form.settlement_bank_address" clearable autocomplete="off" :placeholder="$t('data.bank_address')" />
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item :label="$t('data.swift_code')" prop="swift" :required="form.currency === 'USD'">
                <el-input v-model="form.swift" clearable autocomplete="off" :placeholder="$t('data.swift_code')" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('data.bank_account_proof')" prop="attachment_name">
                <template #label>
                  <span style="color: #71110e;margin-right: 4px;">*</span>
                  {{ $t('data.bank_account_proof') }}
                  <el-tooltip placement="top" :content="$t('data.bank_wallet_tooltip')">
                    <i class="el-icon-question" style="color: #909399; margin-left: 4px; cursor: pointer;" />
                  </el-tooltip>
                </template>
                <div>
                  <div v-if="form.attachment_name" style="margin-bottom: 10px">
                    <div v-if="isImg(form.attachment_content)" class="content-file">
                      <el-image
                        style="height:150px"
                        :src="form.attachment_content_oss_url"
                        :preview-src-list="[form.attachment_content_oss_url]"
                      />
                    </div>
                    <span v-else class="content-file">{{ form.attachment_name }}</span>
                    <el-button type="danger" size="mini" style="margin-left: 10px" icon="el-icon-delete" @click="onClickRemoveBtn">
                      {{ $t('components.delete') }}
                    </el-button>
                  </div>
                  <UploadFile v-else @templateFileSuccess="templateFileSuccess" v-on="$listeners" />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn">
          {{ $t('components.submit') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchDisbursementAllCodeList, getAllCountry } from '@/api/components/components.js'
import { PostMultiMchBankAdd } from '@/api/data/data'

export default {
  name: 'Multi_Mch_Add_Bank_Account_Modal',
  components: {
    UploadFile: () => import('@/views/components/Upload/UploadFile.vue')
  },
  data() {
    const validAttachmentName = (rule, value, callback) => {
      if (!this.form.attachment_name) {
        return callback(new Error('Please upload file'))
      }
      callback()
    }
    const checkNumberType = (rule, value, callback) => {
      if (/\s/g.test(value)) {
        return callback(new Error('The input value cannot contain spaces'))
      }
      callback()
    }
    const validateBankAddress = (rule, value, callback) => {
      if (this.form.currency === 'USD' && !value) {
        return callback(new Error(this.$t('data.bank_address_required')))
      }
      callback()
    }
    const validateSwiftCode = (rule, value, callback) => {
      if (this.form.currency === 'USD' && !value) {
        return callback(new Error(this.$t('data.swift_code_required')))
      }
      callback()
    }
    const validateAccountLocation = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('data.account_location_required')))
      }
      callback()
    }

    return {
      bankList: [],
      countryList: [],
      dialogVisible: false,
      submiting: false,
      form: this.createEmptyForm(),
      rule: {
        currency: [
          { required: true, message: this.$t('data.currency_required'), trigger: ['blur', 'change'] }
        ],
        settlement_country: [
          { validator: validateAccountLocation, trigger: ['blur', 'change'] }
        ],
        settlement_bank: [
          { required: true, message: 'Bank Name cannot be empty', trigger: ['blur', 'change'] }
        ],
        settlement_bank_account_num: [
          { required: true, message: 'Bank Account No. cannot be empty', trigger: ['blur', 'change'] },
          { min: 5, max: 50, message: 'Invalid format.' },
          { validator: checkNumberType, trigger: 'blur' }
        ],
        settlement_bank_account_num_ph: [
          { required: true, message: 'Bank Account No. cannot be empty', trigger: ['blur', 'change'] },
          { min: 5, max: 50, message: 'Invalid format.' },
          { validator: checkNumberType, trigger: 'blur' },
          { pattern: /^\d+$/, message: 'Invalid format.' }
        ],
        settlement_bank_account_name: [
          { required: true, message: 'Bank Account Holder cannot be empty', trigger: ['blur', 'change'] },
          { max: 100, message: 'Bank Account Holder cannot exceed 100 characters.' }
        ],
        attachment_name: [
          { validator: validAttachmentName, message: 'Please upload file', trigger: 'blur' }
        ],
        settlement_bank_address: [
          { validator: validateBankAddress, trigger: ['blur', 'change'] }
        ],
        swift: [
          { validator: validateSwiftCode, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    currencyOptions() {
      const options = [...this.$store.state.page.countryArr]
      const hasUSD = options.some(item => String(item.currency).toUpperCase() === 'USD')
      if (!hasUSD) {
        options.push({ currency: 'USD' })
      }
      return options
    },
    accountLocationList() {
      const useCnName = this.$store.getters.language === 'zh'
      const countries = this.form.currency === 'USD'
        ? this.countryList
        : this.countryList.filter(country => country.code === this.selectedCountryCode)

      return countries.map(country => ({
        label: useCnName ? country.cn_name : country.en_name,
        value: country.code
      }))
    },
    selectedCountryCode() {
      const selectedCountry = this.$store.state.page.countryArr.find(item => item.currency === this.form.currency)
      return selectedCountry ? selectedCountry.code : ''
    }
  },
  created() {
    this.getBankList()
    this.getCountryList()
  },
  methods: {
    createEmptyForm() {
      return {
        attachment_name: null,
        attachment_content: null,
        attachment_content_oss_url: null,
        currency: null,
        settle_type: null,
        settlement_country: null,
        settlement_bank: null,
        settlement_bank_account_num: null,
        settlement_bank_account_num_ph: null,
        settlement_bank_account_name: null,
        settlement_bank_address: null,
        swift: null
      }
    },
    isImg(value) {
      return /\.(gif|jpg|jpeg|png)$/i.test(value)
    },
    getCountryList() {
      getAllCountry().then(res => {
        this.countryList = res.data || []
        this.setDefaultAccountLocation()
      })
    },
    getBankList() {
      const params = this.selectedCountryCode ? { country_code: this.selectedCountryCode } : {}
      fetchDisbursementAllCodeList(params).then(res => {
        this.bankList = res.data || []
      })
    },
    setDefaultAccountLocation() {
      if (this.form.currency && this.form.currency !== 'USD') {
        this.form.settlement_country = this.selectedCountryCode || null
      }
    },
    onCurrencyChange(currency) {
      this.form.settle_type = currency === 'USD' ? 1 : 2
      this.form.settlement_country = currency === 'USD' ? null : (this.selectedCountryCode || null)
      this.form.settlement_bank = null
      this.getBankList()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate([
            'settlement_country',
            'settlement_bank',
            'settlement_bank_address',
            'swift'
          ])
        }
      })
    },
    changeModalStatus(flag) {
      this.dialogVisible = flag
      this.form = this.createEmptyForm()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    onClickRemoveBtn() {
      this.form.attachment_name = null
      this.form.attachment_content = null
      this.form.attachment_content_oss_url = null
    },
    templateFileSuccess(data = {}) {
      this.form.attachment_name = data.fileName
      this.form.attachment_content = data.relativePath
      this.form.attachment_content_oss_url = data.absolutePath
      if (this.$refs.form) {
        this.$refs.form.clearValidate('attachment_name')
      }
    },
    onClickSubmitBtn() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        this.submiting = true
        const params = {
          ...this.form,
          settle_type: this.form.currency === 'USD' ? 1 : 2
        }
        PostMultiMchBankAdd(params).then(() => {
          this.$message.success('Success')
          this.dialogVisible = false
          this.$emit('submit')
        }).finally(() => {
          this.submiting = false
        })
      })
    },
    bankAccountPH() {
      this.form.settlement_bank_account_num = this.form.settlement_bank_account_num_ph
    },
    handleOverflow(event, item) {
      const el = event.target
      if (el && item) {
        this.$set(item, '_overflow', el.scrollWidth > el.clientWidth)
      }
    }
  }
}
</script>

<style scoped>
.singleDisbursementModal /deep/ .el-input--suffix .el-input__inner {
  padding-right: 60px;
}
.select-item {
  width: 100%;
}
.dialog-footer {
  margin-top: -16px;
  text-align: center;
}
.btn-submit {
  width: 500px;
  height: 40px;
  border-radius: 4px;
}
.content-file {
  display: inline-block;
  width: 330px;
  overflow: hidden;
  color: #3855f1;
  text-overflow: ellipsis;
  text-decoration: underline;
  vertical-align: middle;
  white-space: nowrap;
}
.option-ellipsis {
  display: inline-block;
  max-width: 655px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
